import React, {
  useState,
  useRef,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { Card, Col, Row, CardBody, Button } from "reactstrap"
import InfoMeAction from "store/me-resource/actions"
import { Stage, Layer, Line, Text, Image, Transformer, Star } from "react-konva"
import * as Unicons from "@iconscout/react-unicons"
import { CirclePicker } from "react-color"

//Import Breadcrumb

import { v4 as uuidv4 } from "uuid"
import useImage from "use-image"
import Listen from "helpers/Listen"

const TabHandwritingNotebook = forwardRef((props, ref) => {
  const dispatch = useDispatch()
  const state = useSelector(state => state)
  const history = useHistory()
  const params = new URLSearchParams(location.search)
  const id = params.get("id")
  const [activeCanvas, setActiveCanvas] = useState(0)
  const [jsonCanvas, setJsonCanvas] = useState([])
  // const [] = useState
  const [selectedImage, setSelectedImage] = useState("")
  const [imageAtCanvas, setImageAtCanvas] = useState([])
  const [imageList, setImageList] = useState(null)
  const [tool, setTool] = React.useState("pen")
  const [color, setColor] = React.useState("#00000")
  const [lines, setLines] = React.useState([])
  const [penSize, setPenSize] = React.useState(1)

  const stageRef = React.useRef()
  const sideBarRef = React.useRef()
  const divRef = useRef(null)
  const fileRef = useRef()
  const isDrawing = React.useRef(true)

  const INITIAL_CANVAS = {
    id: uuidv4(),
    images: [
      {
        id: uuidv4(),
        img: require("./template.png"),
        x: 50,
        y: 50,
        transformX: 0,
        transformY: 0,
      },
    ],
    lines: [],
  }

  useImperativeHandle(ref, () => ({
    saveCanvas() {
      // let details = []

      // jsonCanvas.map((v, i) => {
      //   const img = stageRef.current.toDataURL()
      //   setActiveCanvas(i)
      //   details.push({
      //     image: img,
      //     json: v,
      //   })
      // })
      let details = []
      setActiveCanvas(0)
      var itr = [...jsonCanvas]
      var interval = 1000 //one second
      itr.forEach((itr, index) => {
        setTimeout(() => {
          const img = stageRef.current.toDataURL()
          details.push({
            image: img,
            json: itr,
          })
          if (index !== jsonCanvas.length - 1) setActiveCanvas(index + 1)
        }, index * interval)
      })

      return { details: details }
    },
  }))

  React.useEffect(() => {
    console.log("payload")
    console.log("payload", props.data)
  }, [])

  React.useEffect(() => {
    console.log(props.data.handwriting.details)

    if (props.data.handwriting) {
      setJsonCanvas(props.data.handwriting.details)
    } else {
      setJsonCanvas([...jsonCanvas, INITIAL_CANVAS])
    }
  }, [props.data])

  React.useEffect(() => {
    Listen.addListener("back", eventResponse)
    return () => Listen.removeListener("back", eventResponse)
  }, [])

  const eventResponse = payload => {
    history.goBack()
  }

  const [dimensions, setDimensions] = useState({
    width: 0,
    height: 0,
    sideBar: 0,
  })

  useEffect(() => {
    if (divRef.current?.offsetHeight && divRef.current?.offsetWidth) {
      setDimensions({
        width: document.getElementById("canvas-container").clientWidth,
        height: divRef.current.offsetHeight,
        sideBar: sideBarRef.current?.offsetWidth,
      })
    }
  }, [dimensions.height])

  const handleDragEnd = e => {
    const findIndexImage = jsonCanvas[activeCanvas].images.findIndex(
      image => image.id === e.imageProps.id
    )
    const cpArr = [...jsonCanvas]
    cpArr[activeCanvas].images[findIndexImage].x = e.e.target.x()
    cpArr[activeCanvas].images[findIndexImage].y = e.e.target.y()
    setJsonCanvas(cpArr)
  }

  const saveCanvas = () => {
    let details = []

    jsonCanvas.map((v, i) => {
      const img = stageRef.current.toDataURL()
      setActiveCanvas(i)
      details.push({
        image: img,
        json: v.json,
      })
    })

    props.setCanvas({ details: details })
  }

  const nextPrev = par => {
    if (par === "next") {
      if (activeCanvas === jsonCanvas.length - 1) {
        return
      } else {
        setActiveCanvas(activeCanvas + 1)
      }
    } else {
      if (activeCanvas === 0) {
        return
      } else {
        setActiveCanvas(activeCanvas - 1)
      }
    }
  }

  const handleMouseDown = e => {
    isDrawing.current = true
    const pos = e.target.getStage().getPointerPosition()
    const clickedOnEmpty = e.target === e.target.getStage()
    if (clickedOnEmpty) {
      setSelectedImage(null)
    }

    setLines([
      ...lines,
      { tool, points: [pos.x, pos.y], color, width: penSize },
    ])

    const cpArr = [...jsonCanvas]

    cpArr[activeCanvas]?.json.lines.push({
      id: uuidv4(),
      tool,
      points: [pos.x, pos.y],
      color,
      width: penSize,
    })
    setJsonCanvas(cpArr)
  }

  const handleMouseMove = e => {
    // no drawing - skipping
    if (!isDrawing.current) {
      return
    }

    if (tool === "") {
      return
    }
    const stage = e.target.getStage()
    const point = stage.getPointerPosition()
    let lastLine = lines[lines.length - 1]
    // add point
    if (lastLine?.points) {
      lastLine.points = lastLine?.points.concat([point.x, point.y])

      // replace last
      lines.splice(lines.length - 1, 1, lastLine)
      setLines(lines.concat())

      // ARRAY
      const cp = [...jsonCanvas]
      const linelength = cp[activeCanvas].json.lines.length
      const lastLinesObj = cp[activeCanvas].json.lines[linelength - 1]
      lastLinesObj.points = lastLinesObj?.points.concat([point.x, point.y])
      cp[activeCanvas].json.lines.splice(linelength - 1, 1, lastLinesObj)
      const a = cp[activeCanvas].json.lines.concat()
      setJsonCanvas(cp)
    }
  }

  const handleMouseUp = () => {
    isDrawing.current = false
  }

  return (
    <React.Fragment>
      <Card>
        <CardBody className="p-3">
          <Row>
            <Row>
              <Col className="col-9 d-flex flex-row justify-content-center align-items-center">
                <div className="d-flex flex-row justify-center align-items-center">
                  <Unicons.UilArrowLeft
                    role="button"
                    size="30"
                    color="#000"
                    onClick={() => nextPrev("prev")}
                  />
                  <div style={{ marginRight: 10, marginLeft: 4 }}>ページ</div>
                  <div style={{ marginRight: 10, fontWeight: "bold" }}>
                    {activeCanvas + 1} / {jsonCanvas.length}
                  </div>
                  <Unicons.UilArrowRight
                    role="button"
                    size="30"
                    color="#000"
                    onClick={() => nextPrev("next")}
                  />
                </div>
              </Col>
              <Col className="col-3 justify-end align-items-end">
                <Button
                  className={["w-100 rounded border bg-primary"].join(" ")}
                  onClick={() => saveCanvas()}
                >
                  保存
                </Button>
              </Col>
            </Row>
          </Row>
        </CardBody>
      </Card>
      <Row style={{ backgroundColor: "#fff" }}>
        <Col className="col-9">
          <Row>
            <Col
              className="col-1 p-2"
              style={{
                backgroundColor: "#f2f2f5",
                justifyItems: "center",
                alignItems: "center",
                // display: "flex",
                flexDirection: "column",
                maxWidth: 55,
              }}
            >
              <div
                style={{
                  maxWidth: 50,
                  backgroundColor: tool === "pen" ? "#dbdbdb" : "#fff",
                  aspectRatio: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: 5,
                  marginBottom: 4,
                }}
              >
                <Unicons.UilEditAlt
                  role="button"
                  size="25"
                  color="#000"
                  onClick={() => setTool("pen")}
                />
              </div>
              <div
                style={{
                  maxWidth: 50,
                  backgroundColor: tool !== "pen" ? "#dbdbdb" : "#fff",
                  aspectRatio: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: 5,
                  marginBottom: 4,
                }}
              >
                <Unicons.UilCapsule
                  role="button"
                  size="25"
                  color="#000"
                  onClick={() => setTool("eraser")}
                />
              </div>
            </Col>
            <Col className="col-11">
              <Card>
                <CardBody className="p-3">
                  <div
                    ref={divRef}
                    style={{
                      width: "100%",
                      height: "65vh",
                    }}
                    id="canvas-container"
                  >
                    <Stage
                      width={dimensions.width}
                      height={dimensions.height}
                      style={{
                        backgroundColor: "#fff",
                        border: "1px solid grey",
                      }}
                      onTouchstart={handleMouseDown}
                      onTouchmove={handleMouseMove}
                      onTouchend={handleMouseUp}
                      onMousedown={handleMouseDown}
                      onMousemove={handleMouseMove}
                      onMouseup={handleMouseUp}
                      ref={stageRef}
                    >
                      <Layer
                        width={dimensions.width}
                        height={dimensions.height}
                      >
                        {jsonCanvas.length > 0 &&
                          jsonCanvas[activeCanvas]?.images.map((image, i) => {
                            return (
                              <Images
                                key={i}
                                imageProps={image}
                                isSelected={image.id === selectedImage}
                                onSelect={() => {
                                  setSelectedImage(image.id)
                                }}
                                onChange={newAttrs => {
                                  const image = imageAtCanvas.slice()
                                }}
                                handleDragEnd={v => handleDragEnd(v)}
                              />
                            )
                          })}

                        {jsonCanvas.length > 0 &&
                          jsonCanvas[activeCanvas]?.lines !== null &&
                          jsonCanvas[activeCanvas]?.lines.map((line, i) => (
                            <Line
                              key={i}
                              points={line.points}
                              stroke={line.color}
                              strokeWidth={line.width}
                              tension={0.5}
                              lineCap="round"
                              globalCompositeOperation={
                                line.tool !== ""
                                  ? line.tool === "eraser"
                                    ? "destination-out"
                                    : "source-over"
                                  : null
                              }
                            />
                          ))}
                      </Layer>
                    </Stage>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Col>

        <Col className="col-3">
          <Card>
            <CardBody className="p-3 h-100">
              <div ref={divRef} style={{ width: "100%", height: "65vh" }}>
                <Row style={{ height: "25%" }}>
                  <Col className="col-12">
                    <div style={{ marginBottom: 4 }}>Pen Size</div>
                    <input
                      type="range"
                      id="pensize"
                      name="pensize"
                      min="0"
                      max="11"
                      style={{ width: "100%" }}
                      value={penSize}
                      onChange={e => setPenSize(e.target.value)}
                    />
                  </Col>
                  <Col className="col-12 mt-4">
                    <div style={{ marginBottom: 6 }}>Pen Color</div>
                    <CirclePicker
                      styles={{ width: "100%" }}
                      circleSize={20}
                      circleSpacing={5}
                      onChange={color => setColor(color.hex)}
                      width={"100%"}
                    />
                  </Col>
                </Row>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
})

const Images = ({
  imageProps,
  isSelected,
  onSelect,
  onChange,
  handleDragEnd,
}) => {
  const shapeRef = React.useRef()
  const trRef = React.useRef()
  const [image] = useImage(imageProps.img, "anonymous")

  React.useEffect(() => {
    if (isSelected) {
      // we need to attach transformer manually
      trRef.current.nodes([shapeRef.current])
      trRef.current.getLayer().batchDraw()
    }
  }, [isSelected])

  return (
    <React.Fragment>
      <Image
        image={image}
        x={imageProps.x}
        y={imageProps.y}
        width={image ? image.width / 2 : 0}
        height={image ? image.height / 2 : 0}
        ref={shapeRef}
        {...imageProps}
        draggable={isSelected}
        onDragEnd={e => {
          handleDragEnd({ imageProps, e })

          onChange({
            ...imageProps,
            x: e.target.x(),
            y: e.target.y(),
          })
          // handleDragEnd
        }}
        onTransformEnd={e => {
          const node = shapeRef.current
          const scaleX = node.scaleX()
          const scaleY = node.scaleY()
          // console.log(scaleX)
          onChange({
            ...imageProps,
            x: node.x(),
            y: node.y(),
            // set minimal value
            width: Math.max(5, node.width() * scaleX),
            height: Math.max(node.height() * scaleY),
          })
        }}
      ></Image>
      {isSelected && (
        <Transformer
          ref={trRef}
          boundBoxFunc={(oldBox, newBox) => {
            // limit resize
            if (newBox.width < 5 || newBox.height < 5) {
              return oldBox
            }
            return newBox
          }}
        />
      )}
    </React.Fragment>
  )
}

export default TabHandwritingNotebook
